var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendarClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Icon=calendar_clock, hover=no, Selected=no"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_447_11520",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    y: 0.380951,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_447_11520)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "calendar_clock",
    d: "M5 8.38095H19V6.38095H5V8.38095ZM5 22.381C4.45 22.381 3.97917 22.1851 3.5875 21.7935C3.19583 21.4018 3 20.931 3 20.381V6.38095C3 5.83095 3.19583 5.36012 3.5875 4.96845C3.97917 4.57678 4.45 4.38095 5 4.38095H6V2.38095H8V4.38095H16V2.38095H18V4.38095H19C19.55 4.38095 20.0208 4.57678 20.4125 4.96845C20.8042 5.36012 21 5.83095 21 6.38095V12.056C20.6833 11.906 20.3583 11.781 20.025 11.681C19.6917 11.581 19.35 11.506 19 11.456V10.381H5V20.381H11.3C11.4167 20.7476 11.5542 21.0976 11.7125 21.431C11.8708 21.7643 12.0583 22.081 12.275 22.381H5ZM18 23.381C16.6167 23.381 15.4375 22.8935 14.4625 21.9185C13.4875 20.9435 13 19.7643 13 18.381C13 16.9976 13.4875 15.8185 14.4625 14.8435C15.4375 13.8685 16.6167 13.381 18 13.381C19.3833 13.381 20.5625 13.8685 21.5375 14.8435C22.5125 15.8185 23 16.9976 23 18.381C23 19.7643 22.5125 20.9435 21.5375 21.9185C20.5625 22.8935 19.3833 23.381 18 23.381ZM19.675 20.756L20.375 20.056L18.5 18.181V15.381H17.5V18.581L19.675 20.756Z",
    fill: "#59565F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarClock);
export default __webpack_public_path__ + "static/media/calendar_clock.d3999cf28c5206f53c6e4393dd49b7b7.svg";
export { ForwardRef as ReactComponent };